export default __webpack_public_path__ + "static/media/regulatory--no-overtaking--g2.2b83574c.png";